export default __webpack_public_path__ + "static/media/Profile_Picture_Mac_20260408.df2063cc.jpg";